<template>
  <div class="list">
    <div class="list_row" v-for="(item, index) in list" :key="index">
      <div class="list_row_text" v-text="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  width: 100%;
  .list_row {
    width: 95%;
    display: flex;
    margin: 0px auto;
    margin-top: 5px;
    line-height: 30px;
    height: 30px;
    font-size: 16px;
    border-bottom: 1px solid #bdc3c7;
    .list_row_text {
       overflow:hidden;
       text-overflow: ellipsis;
    white-space: nowrap;
      color: #646566;
      text-align: center;
    }
  }
}
</style>